export default __webpack_public_path__ + "static/media/vip_points_blue.ecd9def9.svg";